$(document).ready(function () {
    var data = $('.customerGallerySlider').attr('data')?.replace(/\s*/g, "")
    if (!data) return

    var customerArr = JSON.parse(data)
    var html = ``
    customerArr.forEach(element => {
        html += `
            <div class="swiper-slide custSlider">
            <img src="${element}" alt="">
        </div>
        `
    });

    $('.customerGallerySlider .swiper-wrapper').append(html)

    var bigSwiper = ``
    customerArr.forEach(element => {
        bigSwiper += `
            <div class="swiper-slide">
            <img src="${element}" alt="">
        </div>
        `
    });

    $('.mySwiper-gallery-content .swiper-wrapper').append(bigSwiper)


    var swiperCust = null
    function getWindowWidth(w) {
        if (w < 1850 && w > 1550) {
            return 5;
        } else if (w < 1550 && w > 1250) {
            return 4;
        } else if (w < 1250 && w > 800) {
            return 3;
        } else if (w < 800 && w > 600) {
            return 2;
        } else if (w < 600) {
            return 1;
        } else {
            return 6;
        }
    }
    function initSwiperCust() {
        if (swiperCust) return
        setTimeout(() => {
            swiperCust = new Swiper(".mySwiper-cust", {
                lazy: true,
                slidesPerView: getWindowWidth($(window).width()),
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }
            });
        })
    }
    $('.initCustSwiper').click(function () {
        initSwiperCust()
    })


    function initBigSwiper(index) {
        var swiper2 = new Swiper(".mySwiper2", {
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });
        if (index) {
            swiper2.slideTo(index);
        }
    }
    $('.custSlider').click(function () {
        // initBigSwiper()
        $('.mySwiper-gallery-box').css('display', 'block')
        $('.mySwiper-gallery-box').css('visibility', 'inherit')
        initBigSwiper($(this).index())
    })

    $('.gallery-icon-close').click(function () {
        $('.mySwiper-gallery-box').css('display', 'none')
        $('.mySwiper-gallery-box').css('visibility', 'hidden')
    })

})